import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Bullets.scss';
import Bullet from './Bullet';

const rootClassName = styles.rootClassName;

class Bullets extends Component {
  getBullets = () => {
    let i;
    let bullets = [];
    for (i = 0; i < this.props.total; ++i) {
      bullets.push(i === this.props.selectedIndex ? true : false);
    }
    return bullets;
  };

  render() {
    const bullets = this.getBullets();
    return (
      <div className={rootClassName}>
        {bullets.map((bullet, index) => {
          return <Bullet actived={bullet} key={index} />;
        })}
      </div>
    );
  }
}

Bullets.propTypes = {
  total: PropTypes.number.isRequired,
  selectedIndex: PropTypes.number.isRequired,
};

export default Bullets;
